(() => {
  const eventName = 'Easify Photo Added to Cart';
  const uploadProperty = 'Pet Photo Upload';

  function sendToKlaviyo(data, attempt = 0) {
    if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      window.klaviyo.track(eventName, data);
    } else if (attempt < 20) {
      window.setTimeout(() => sendToKlaviyo(data, attempt + 1), 250);
    }
  }

  function text(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function easifyEvent(item, properties) {
    const uploadedFile = properties[uploadProperty];
    if (typeof uploadedFile !== 'string' || !uploadedFile.startsWith('https://cdn.tigren.com/uploads/')) return null;

    const eventData = { UploadedFileURL: uploadedFile };

    const originalFile = properties['_Pet Photo Upload_original'];
    if (typeof originalFile === 'string' && originalFile.startsWith('https://cdn.tigren.com/uploads/')) {
      eventData.OriginalFileURL = originalFile;
    }

    if (text(properties['Pet name'])) eventData.PetName = text(properties['Pet name']);
    if (text(properties['Portrait Style'])) eventData.PortraitStyle = text(properties['Portrait Style']);
    return eventData;
  }

  // Teeinblue (Pawlight AI + Pawframe): preview image, optional original photo, style and name
  function teeinblueEvent(item, properties) {
    const preview = properties._customization_image;
    if (typeof preview !== 'string' || !preview.startsWith('https://')) return null;

    const originalPhoto = text(properties._original_photo);
    const eventData = {
      Source: 'Teeinblue',
      PreviewImageURL: preview,
      UploadedFileURL: originalPhoto || preview
    };

    if (originalPhoto) eventData.OriginalFileURL = originalPhoto;
    if (text(properties._tib_design_link_1)) eventData.DesignFileURL = text(properties._tib_design_link_1);
    if (text(properties['Pet name'])) eventData.PetName = text(properties['Pet name']);
    if (text(properties['Choose your style'])) eventData.PortraitStyle = text(properties['Choose your style']);
    if (text(properties['Wall hook'])) eventData.WallHook = text(properties['Wall hook']);
    return eventData;
  }

  // Built-in personalizer (Memento, Familiar bundle, Pawlight builtin): photos uploaded to Shopify
  function builtinEvent(item, properties) {
    const photos = Object.keys(properties)
      .filter(key => /^pet photo( \d+)?$/i.test(key))
      .map(key => text(properties[key]))
      .filter(url => url.startsWith('https://'));
    if (!photos.length) return null;

    const eventData = { Source: 'Built-in', UploadedFileURL: photos[0], PhotoCount: photos.length };
    photos.slice(1).forEach((url, i) => { eventData['UploadedFileURL' + (i + 2)] = url; });

    const name = text(properties["Pet's Name"]) || text(properties['Pet name']);
    if (name) eventData.PetName = name;
    const style = text(properties.Style) || text(properties['Coin Pouch Pattern']);
    if (style) eventData.PortraitStyle = style;
    if (text(properties['Memorial Year'])) eventData.MemorialYear = text(properties['Memorial Year']);
    if (text(properties['About Them'])) eventData.AboutThem = text(properties['About Them']);
    if (text(properties['Special Instructions'])) eventData.SpecialInstructions = text(properties['Special Instructions']);
    return eventData;
  }

  function trackAddedItems(result) {
    const items = Array.isArray(result?.items) ? result.items : [result];

    for (const item of items) {
      const properties = item?.properties;
      if (!properties || typeof properties !== 'object') continue;

      const eventData = easifyEvent(item, properties) || teeinblueEvent(item, properties) || builtinEvent(item, properties);
      if (!eventData) continue;

      sendToKlaviyo({
        ProductID: String(item.product_id || ''),
        VariantID: String(item.variant_id || item.id || ''),
        ProductName: item.product_title || item.title || '',
        VariantName: item.variant_title || '',
        ...eventData
      });
    }
  }

  function isCartAdd(url, method) {
    if (String(method).toUpperCase() !== 'POST') return false;

    try {
      const path = new URL(url, window.location.href).pathname;
      return /(?:^|\/)cart\/add(?:\.js)?\/?$/.test(path);
    } catch {
      return false;
    }
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const input = args[0];
    const options = args[1];
    const url = typeof input === 'string' ? input : input?.url;
    const method = options?.method || input?.method || 'GET';
    const responsePromise = originalFetch.apply(this, args);

    if (isCartAdd(url, method)) {
      responsePromise.then(response => {
        if (response.ok) {
          response.clone().json().then(trackAddedItems).catch(() => {});
        }
      }).catch(() => {});
    }

    return responsePromise;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this.easifyKlaviyoCartAdd = isCartAdd(url, method);
    return originalOpen.call(this, method, url, ...args);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this.easifyKlaviyoCartAdd) {
      this.addEventListener('load', () => {
        if (this.status < 200 || this.status >= 300) return;

        try {
          const result = this.responseType === 'json' ? this.response : JSON.parse(this.responseText);
          trackAddedItems(result);
        } catch {}
      }, { once: true });
    }

    return originalSend.apply(this, args);
  };
})();
